// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2022project/q1/2022forever/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};
const getIndex = (data: any) => {
  return http.post(`${urlPrefix}index`, qs.stringify(data));
};

const getList = (page: any) => {
  return http.get(`${urlPrefix}comment-list&page=${page}`);
};

const save = (data: any) => {
  return http.post(`${urlPrefix}comment-save`, qs.stringify(data));
};

const getDetail = (id: any) => {
  return http.post(`${urlPrefix}comment-detail&id=${id}`);
};
const getNews = (page: any, category: any, classId: any) => {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
};
export { getBaseInfo, getIndex, getList, save, getDetail, getNews };
